import React from 'react';
import "./Step.scss";
const StepTwo = ({ activeStep,setActiveStep,nextStep,prevStep,setPaiement, paiement }) => {
    return (
     <div className='step-component step-two'>
        <div className='separator'>
           <h1>Informations du demandeur</h1>
        </div>
        <div className='group-info'>
            <div className='group-info-item'>
                <p>Type de demandeur</p>
                <p>{paiement.demandeur.typeDemandeur.charAt(0).toUpperCase() + paiement.demandeur.typeDemandeur.slice(1) || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>Prénom et Nom</p>
                <p>{paiement.demandeur.fullName || "N/A"}</p>
            </div>
        </div>
        <div className='group-info'>
            <div className='group-info-item'>
                <p>Email</p>
                <p>{paiement.demandeur.email || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>Téléphone</p>
                <p>{paiement.demandeur.telephone || "N/A"}</p>
            </div>
        </div>
        <div className='group-info'>
          <div className='group-info-item'>
                <p>Adresse</p>
                <p>{paiement.demandeur.adresse || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>N°Identification Nationale</p>
                <p>{paiement.demandeur.nina || "N/A"}</p>
            </div>
        </div>
        {(paiement.demandeur.typeDemandeur === "concessionnaire"  || paiement.demandeur.typeDemandeur === "constructeur")&&
        <div className='group-info'>
            <div className='group-info-item'>
                <p>Nom de la société</p>
                <p>{paiement.demandeur.denominationSociete || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>N°RCCM</p>
                <p>{paiement.demandeur.rccm || "N/A"}</p>
            </div>
        </div>
        }
        <div className='buttons'>
            <button className="secondary" onClick={prevStep}>
              Précedent
            </button>
            <button className="" onClick={nextStep}>
               Suivant
            </button>
         </div>
     </div>
    )
 }
 
 export default StepTwo;